module.exports = __webpack_public_path__ + "fonts/nunito-sans-latin-300italic.32bb6ae.woff";